import { ActionReducer, DataForm } from './types'

export const formReducer = (state: DataForm, action: ActionReducer): DataForm => {
  switch (action.type) {
    case 'setInitialForm':
      return {
        ...state,
        ...action.payload,
      }
    case 'handleCenter':
      return {
        ...state,
        ...action.payload,
      }
    case 'setCageSelection':
      return {
        ...state,
        cageId: action.payload.cageId,
        cageName: action.payload.cageName,
        formId: action.payload.formId,
      }
    case 'setSinglePhoto':
      const { attribute, photo } = action.payload
      return {
        ...state,
        [attribute]: photo,
      }

    case 'setAdditionalPhoto':
      return {
        ...state,
        additionalPhotos: {
          ...state.additionalPhotos,
          [new Date().getTime()]: action.payload.photo,
        },
      }
    case 'removeAdditionalPhoto':
      const { [action.tempId]: toDelete, ...rest } = state.additionalPhotos

      return {
        ...state,
        additionalPhotos: { ...rest },
      }

    case 'finalForm':
      return {
        ...state,
        comments: action.comments,
        stateForm: 'pending',
      }
    case 'resetData':
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
